import * as Yup from 'yup';
import { InputProps } from '../interfaces/input-props';
import { checkVisibilityCondition } from '../utils/check-visibility-condition';
import { AnyObject } from 'yup';
import { FormTypes } from '../interfaces/form-types';
import { forms } from '../form-values';

type YupString = Yup.StringSchema;
type YupArray = Yup.ArraySchema<string[] | undefined, AnyObject>;

const _generateValidations = (field: InputProps): YupString | YupArray | null => {
	if (!field.validations) return null;

	let schema: YupArray | YupString | null = null;

	if (field.multi) {
		schema = Yup.array();
	} else {
		schema = Yup.string();
	}

	for (const rule of field.validations) {
		switch (rule.type) {
			case 'minLength':
				schema = (schema as YupArray).min(rule.value as number, rule.message);
				break;
			case 'maxLength':
				schema = (schema as YupArray).max(rule.value as number, rule.message);
				break;
			default:
				schema = schema.required(rule.message);
				break;
		}
	}
	return schema;
};

export const getInputs = <T>(type: FormTypes) => {
	const initialValues: Record<string, string | number | boolean | string[]> = {};

	const validationsFields: Record<string, YupString | YupArray> = {};

	for (const field of forms[type]) {
		if (!field.validations) continue;

		let isVisible = true;

		if (field.visibleWhen) {
			for (const condition of field.visibleWhen) {
				if (!checkVisibilityCondition(condition, {}, condition.value.toString())) {
					isVisible = false;
					break;
				}
			}
		}

		if (!isVisible) continue;

		const schema = _generateValidations(field);

		if (schema) {
			validationsFields[field.name] = schema;
		}
	}

	return {
		validationSchema: Yup.object({ ...validationsFields }),
		initialValues: initialValues as T,
		inputs: forms[type],
	};
};
